import React from 'react'
import { Link } from 'react-router-dom'
import '../styles/components/CTA.css'

const CTA = () => {
  return (
    <section className="cta">
      <div className="cta-container">
        <div className="cta-content">
          <h2 className="cta-title">
            Ready to Transform Your Business?
          </h2>
          <p className="cta-subtitle">
            Let's discuss how we can help you grow faster, operate smarter, 
            and compete globally.
          </p>
          
          <div className="cta-info">
            <div className="cta-item">
              <span className="cta-icon">📧</span>
              <span>info@figodigitalservice.com</span>
            </div>
            <div className="cta-item">
              <span className="cta-icon">🌐</span>
              <span>figodigitalservices.com</span>
            </div>
            <div className="cta-item">
              <span className="cta-icon">📍</span>
              <span>Abuja | Lagos | Global</span>
            </div>
          </div>
          
          <div className="cta-actions">
            <Link to="/contact" className="cta-button primary">
              Schedule Free Consultation
            </Link>
            <button className="cta-button secondary">
              Download Portfolio
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CTA
